var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5263 13.6666H3.53912C3.20236 13.6666 2.91732 13.55 2.68398 13.3166C2.45065 13.0833 2.33398 12.7983 2.33398 12.4615V3.53848C2.33398 3.20172 2.45065 2.91668 2.68398 2.68334C2.91732 2.45001 3.20236 2.33334 3.53912 2.33334H12.4622C12.7989 2.33334 13.084 2.45001 13.3173 2.68334C13.5506 2.91668 13.6673 3.20172 13.6673 3.53848V10.5256L10.5263 13.6666ZM10.0006 12.6667V11.3333C10.0006 10.9667 10.1312 10.6528 10.3923 10.3917C10.6534 10.1306 10.9673 9.99999 11.334 9.99999H12.6673V3.53848C12.6673 3.48719 12.6459 3.44017 12.6032 3.39743C12.5605 3.35469 12.5134 3.33333 12.4622 3.33333H3.53912C3.48783 3.33333 3.44081 3.35469 3.39807 3.39743C3.35533 3.44017 3.33397 3.48719 3.33397 3.53848V12.4615C3.33397 12.5128 3.35533 12.5598 3.39807 12.6026C3.44081 12.6453 3.48783 12.6667 3.53912 12.6667H10.0006Z",
    fill: "black",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96224 8.15384V9.15383H8.00067V8.15384H4.96224Z",
    fill: "black",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96224 5.50001V6.49998H11.0391V5.50001H4.96224Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientActivity);
export default __webpack_public_path__ + "static/media/ClientActivity.30966ab8f38009d5850b4fc6dd2d404d.svg";
export { ForwardRef as ReactComponent };